/**
 * The sidebar keeps its own maroon palette in both color modes, so these are
 * plain values rather than semantic tokens. Dark mode uses a deeper, cooler
 * top-to-bottom fall so the rail settles into the page wash instead of
 * glowing against it.
 */
export const sidebarStyles = {
  bg: 'linear-gradient(180deg, #33202A 0%, #431A26 40%, #5A1922 75%, #641A20 100%)',
  bgDark:
    'linear-gradient(180deg, #1D0F14 0%, #2A121A 40%, #45161F 78%, #5B1922 100%)',
  fg: 'rgba(255, 255, 255, 0.62)',
  fgHover: 'rgba(255, 255, 255, 0.92)',
  fgActive: '#FFFFFF',
  hoverBg: 'rgba(255, 255, 255, 0.08)',
  activeBg: '#FFFFFF',
  activeFg: '#641A20',
  divider: 'rgba(255, 255, 255, 0.12)',
  /** Knock-out color for marks drawn on a filled icon (the rail's base tone). */
  markOnFill: '#641A20',
  markOnFillDark: '#5B1922',
  /** Lit hairline that reads as glass against the dark wash. */
  borderDark: 'rgba(255, 255, 255, 0.08)',
  /** Floating card: detached from the viewport edges, lifted by a shadow. */
  inset: '12px',
  radius: '20px',
  shadow: '0 10px 30px rgba(51, 22, 30, 0.28)',
  shadowDark: '0 12px 40px rgba(0, 0, 0, 0.5)',
} as const
